import CheckGreenIcon from 'assets/ver2/icons/check-green-icon.svg';
import CloseGreyIcon from 'assets/ver2/icons/close-circle-grey-icon.svg';
import SizeBox from 'components/common/SizeBox';
import {
  DESKTOP_MIN_WIDTH,
  MOBILE_MIN_WIDTH,
  TABLET_MAX_WIDTH,
} from 'constants';
import FormPIIProfilePersonalDetails from 'features/pii/components/FormPIIProfilePersonalDetails';
import FormPIIProfileResidentialAddress from 'features/pii/components/FormPIIProfileResidentialAddress';
import RibbonSteps from 'features/pii/components/RibbonSteps';
import usePIIStore from 'features/pii/hooks/usePIIStore';
import useLang from 'hooks/useLang';
import usePortalModal from 'hooks/usePortalModal';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';
import { cursorPointerMixin, scrollbarThumbMixin } from 'styles';
import ConfirmCloseFormPIIModal from '../../ConfirmCloseFormPIIModal';

const FormPIIPopup = ({
  isOpen,
  isBackdropOverlap,
  zIndexBackdropOverlap,
  zIndexModal = 0,
}) => {
  const { t } = useLang();
  const { closePortalModalName } = usePortalModal();
  const { resetSignupPIIInformation } = usePIIStore();

  const [currentStep, setCurrentStep] = useState(0);
  const [isShowConfirmCloseFormPIIModal, setShowConfirmCloseFormPIIModal] =
    useState(false);

  const renderHeaderContent = () => {
    return (
      <>
        <CheckIcon src={CheckGreenIcon} width={70} height={70} />
        <CloseIcon
          src={CloseGreyIcon}
          width={30}
          height={30}
          onClick={handleShowConfirmCloseFormPIIModal}
        />
      </>
    );
  };

  const renderFormPIIStep = () => {
    return (
      <>
        <SizeBox height={5} />
        <RibbonSteps
          currentStep={currentStep}
          stepLabels={[
            t('label_personal_details'),
            t('label_residential_address'),
          ]}
        />
        <SizeBox height={30} />
      </>
    );
  };
  const formPIIModalStepReference = {
    0: (
      <FormPIIProfilePersonalDetails
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
      />
    ),
    1: (
      <FormPIIProfileResidentialAddress
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
      />
    ),
  };
  const renderBodyContent = () => (
    <>
      {renderFormPIIStep()}
      {formPIIModalStepReference[currentStep]}
    </>
  );

  const hanleOnCloseFormPIIModal = () => {
    resetSignupPIIInformation();
    closePortalModalName();
  };

  const handleShowConfirmCloseFormPIIModal = () => {
    setShowConfirmCloseFormPIIModal(true);
  };
  const handleCloseConfirmCloseFormPIIModal = () => {
    setShowConfirmCloseFormPIIModal(false);
  };

  return (
    <>
      {isShowConfirmCloseFormPIIModal && (
        <ConfirmCloseFormPIIModal
          isShow={isShowConfirmCloseFormPIIModal}
          action={handleCloseConfirmCloseFormPIIModal}
          actionClose={hanleOnCloseFormPIIModal}
        />
      )}
      <style>
        {zIndexModal &&
          `
          .form-pii-modal {
            z-index: ${zIndexModal || '1101'};
          }
        `}
        {isBackdropOverlap
          ? `
          .form-pii-modal-backdrop {
            z-index: ${zIndexBackdropOverlap || '1100'};
            background: #212121;
            opacity: 0.7!important;
            display: initial!important;
          }
        `
          : `
        .form-pii-modal-backdrop {
          background: #212121;
          opacity: 0.7!important;
          display: initial!important;
        }
      `}
      </style>
      <ModalStyled
        show={isOpen}
        onHide={() => {}}
        aria-labelledby="contained-modal-title-vcenter"
        className="form-pii-modal"
        backdropClassName="form-pii-modal-backdrop"
        centered
      >
        <ModalHeader>{renderHeaderContent()}</ModalHeader>
        <ModalBody>{renderBodyContent()}</ModalBody>
      </ModalStyled>
    </>
  );
};

const ModalStyled = styled(Modal)`
  padding-left: 0px !important;
  padding-right: 0px !important;

  @media screen and (min-width: ${MOBILE_MIN_WIDTH}px) and (max-width: ${TABLET_MAX_WIDTH -
    1}px) {
    & .modal-dialog {
      position: absolute;
      margin: 0;
      top: 0px;
      height: 100dvh;
      width: 100%;
      max-width: 100%;
      align-items: end;
      transition: ease-out 0.3s !important;
      transform: none;

      & .modal-content {
        padding: 0px 16px;
        box-shadow: none;
        background: var(--ds-c-white);
        width: 100%;
        min-height: calc(100dvh - 70px);
        max-height: calc(100dvh - 70px);
        margin-inline: auto;
        border: none;
        border-radius: 16px 16px 0 0;
      }
    }
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    & .modal-dialog {
      transform: none;
      & .modal-content {
        padding: 50px 40px 40px 40px;
        box-shadow: var(--ds-bs-4);
        background: var(--ds-c-white);
        width: 516px;
        height: fit-content;
        margin-inline: auto;
        border: none;
        border-radius: 20px;
      }
    }
  }
`;

const ModalHeader = styled.div`
  margin-top: -35px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    margin-top: -87.5px;
  }
`;
const CheckIcon = styled.img`
  display: block;
  margin-inline: auto;
`;
const CloseIcon = styled.img`
  ${cursorPointerMixin};
  position: absolute;
  top: -35px;
  right: 16px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    right: 0px;
  }
`;

const ModalBody = styled(Modal.Body)`
  padding: 0;
  text-align: left;
  margin-bottom: 0px;
  overflow-x: auto;
  margin-inline: -16px;
  padding-inline: 16px;
  ${scrollbarThumbMixin};

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    overflow-x: unset;
  }
`;

export default FormPIIPopup;
